export { IxTabs } from './IxTabs.js';
export { IxPrimaryTab } from './IxPrimaryTab.js';
